module.exports = __webpack_public_path__ + "img/home-btn-zalo.321af115.svg";